import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { TrackedButton } from "@outschool/ui-components-shared";
import React from "react";

type FilterActionButtonProps = {
  onApply: () => void;
  resetFilters?: () => void;
};

export default function FilterActionButtons({
  onApply,
  resetFilters,
}: FilterActionButtonProps) {
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\FilterActionButtons",
  );
  return (
    <Box
      flex
      sx={{
        zIndex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: "1em",
        minWidth: "200px",
        paddingY: "1em",
        background: "white",
        borderTop: "1px solid #DDDFE3",
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        paddingX: "1em",
      }}
    >
      <TrackedButton
        variant="link"
        onClick={resetFilters}
        trackingName="mobile_sbs_button_modal_reset_filter"
      >
        {t("Reset Filters")}
      </TrackedButton>
      <TrackedButton
        variant="contained"
        onClick={onApply}
        trackingName="mobile_sbs_button_modal_advance_search"
      >
        {t("Apply")}
      </TrackedButton>
    </Box>
  );
}
